/**
 * Faz 9 vitrin metinleri (öneriler, yeniden alım zamanı, yapay zekâ görsel notu). Vitrin girişi
 * (`@zt/i18n/storefront`) yalnızca `storefront.*` gördüğü için `storefront.tr.ts` → `storefrontTr.ai` altına bağlanır.
 */
export const storefrontAiTr = {
  alsoBought: 'Bu ürünü alanlar bunları da aldı',
  cartRecommendations: 'Sepetinize eklenebilecekler',
  replenishmentTitle: 'Yeniden alım zamanı yaklaşanlar',
  replenishmentLead:
    'Önceki siparişlerinize göre tahmini tarihler; dilerseniz şimdiden sepete ekleyebilirsiniz.',
  replenishmentDue: 'Tahmini yeniden alım: {{date}}',
  aiImage: 'Yapay zekâ ile üretilmiş görsel',
  replenishmentOverdue: 'Tahmini yeniden alım tarihi geçti ({{date}})',
  replenishmentBasis: {
    own: 'yaklaşık {{days}} günde bir alıyorsunuz',
    typical: 'bu ürün genellikle {{days}} günde bir alınıyor',
  },
};
